export default function identity (d) {
	return d;
}
